export default "__VITE_ASSET__D6eAR3h4__"